import React, { SVGProps } from 'react';

export default function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="icon_instagram"
      height="1.5em"
      viewBox="0 0 24 24"
      width="1.5em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={12} cy={12} fill="#de3073" r={12} />
      <path
        d="M18.958 9.116a5.121 5.121 0 00-.336-1.708 3.557 3.557 0 00-2.044-2.044 5.12 5.12 0 00-1.694-.322C14.142 5.014 13.89 5 12 5s-2.142.014-2.884.042a5.213 5.213 0 00-1.708.322 3.665 3.665 0 00-2.044 2.044 5.213 5.213 0 00-.322 1.708C5.014 9.858 5 10.1 5 12s.014 2.142.042 2.884a5.12 5.12 0 00.322 1.694 3.44 3.44 0 00.812 1.246 3.4 3.4 0 001.232.8 5.175 5.175 0 001.708.336c.742.028.98.042 2.884.042s2.142-.014 2.884-.042a5.082 5.082 0 001.694-.336 3.456 3.456 0 002.044-2.044 5.006 5.006 0 00.336-1.694C18.986 14.142 19 13.9 19 12s-.014-2.142-.042-2.884zM17.7 14.828a3.946 3.946 0 01-.252 1.3 2.189 2.189 0 01-.518.8 2.165 2.165 0 01-.8.532 4.641 4.641 0 01-1.3.238c-.742.028-.966.042-2.828.042s-2.1-.014-2.828-.042a3.837 3.837 0 01-1.3-.252A2.258 2.258 0 016.54 16.13a3.91 3.91 0 01-.238-1.3c-.028-.742-.042-.966-.042-2.828s.014-2.086.042-2.828a3.787 3.787 0 01.238-1.3A2.445 2.445 0 017.87 6.54a3.856 3.856 0 011.3-.238c.742-.028.952-.042 2.828-.042s2.086.014 2.828.042a3.787 3.787 0 011.3.238 2.445 2.445 0 011.33 1.33 4.641 4.641 0 01.238 1.3c.027.742.042.952.042 2.828s-.011 2.088-.036 2.83zM12 8.4a3.6 3.6 0 103.6 3.6A3.6 3.6 0 0012 8.4zm.181 5.929a2.338 2.338 0 01-.362-4.662 2.43 2.43 0 01.362 0 2.338 2.338 0 010 4.662zm3.557-6.909a.84.84 0 11-.84.84.84.84 0 01.84-.838z"
        fill="#fff"
      />
    </svg>
  );
}
